module.exports = __webpack_public_path__ + "img/KIDIWI_services-candy.7016db0f.svg";